import { Pipe, PipeTransform, inject } from '@angular/core';
import { Balance, Money } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { getPostPaymentPrice } from 'mbs-ui-shared@components/licenses/utils/price.util';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  transform(value: Money | string | number, period?: string): Observable<string> {
    return this.balance.pipe(switchMap((balance) => of(getPostPaymentPrice(balance, value, period))));
  }
}
